import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth, api } from '../App';
import { QrCode, Loader2 } from 'lucide-react';

export default function QrRedirect() {
  const { uuid } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/qr/info/${uuid}`)
      .then(({ data }) => {
        // Giriş yapmış kullanıcı → checklist varsa checklist, yoksa anket
        if (user) {
          if (data.checklist_id) {
            navigate(`/checklist/${uuid}`, { replace: true });
          } else if (data.anket_id) {
            navigate(`/anket/${uuid}`, { replace: true });
          } else {
            setError('Bu lokasyona henüz anket veya checklist tanımlanmamış.');
          }
        } else {
          // Giriş yapmamış → anket varsa anket
          if (data.anket_id) {
            navigate(`/anket/${uuid}`, { replace: true });
          } else {
            setError('Bu lokasyona henüz anket tanımlanmamış.');
          }
        }
      })
      .catch(() => setError('Geçersiz veya tanımlanamayan QR kodu'));
  }, [uuid, user, navigate]);

  if (error) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(145deg, #1d4ed8, #1e3a8a)',
      padding: 16
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: 40,
        textAlign: 'center', maxWidth: 360, width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        <QrCode size={48} color="#d97706" style={{ margin: '0 auto 16px' }} />
        <h2 style={{ color: '#1e293b', margin: '0 0 8px', fontSize: 18, fontWeight: 700 }}>QR Kod Hatası</h2>
        <p style={{ color: '#64748b', fontSize: 13, margin: 0 }}>{error}</p>
      </div>
    </div>
  );

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(145deg, #1d4ed8, #1e3a8a)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <Loader2 size={36} color="#fff" style={{ animation: 'spin 0.7s linear infinite', marginBottom: 14 }} />
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>Yönlendiriliyor...</p>
      </div>
    </div>
  );
}
